module.exports = __webpack_public_path__ + "static/media/photography.ba9c7f6d.png";